"use client";

import React, { ReactNode } from "react";
import { ActivityProvider } from "./ActivityContext";
import { SettingsProvider } from "./SettingsContext";
import { CustomerProvider } from "./CustomerContext";
import { VehicleProvider } from "./VehicleContext";
import { PackageProvider } from "./PackageContext";
import { SubscriptionProvider } from "./SubscriptionContext";
import { InvoiceProvider } from "./InvoiceContext";
import { AppointmentProvider } from "./AppointmentContext";
import { StaffProvider } from "./StaffContext";
import { StaffTimeTrackingProvider } from "./StaffTimeTrackingContext";

/**
 * AllProviders composes all context providers in the correct dependency order.
 * 
 * Dependency order:
 * 1. ActivityProvider - Base utility context (no dependencies)
 * 2. SettingsProvider - Base context (no dependencies)
 * 3. CustomerProvider - Depends on ActivityProvider
 * 4. VehicleProvider - Depends on CustomerProvider
 * 5. PackageProvider - Independent
 * 6. SubscriptionProvider - Depends on CustomerProvider, ActivityProvider
 * 7. InvoiceProvider - Depends on CustomerProvider, ActivityProvider
 * 8. AppointmentProvider - Depends on CustomerProvider, VehicleProvider, SubscriptionProvider, ActivityProvider
 * 9. StaffProvider - Independent (for authentication)
 */
export function AllProviders({ children }: { children: ReactNode }) {
  return (
    <ActivityProvider>
      <SettingsProvider>
        <CustomerProvider>
          <VehicleProvider>
            <PackageProvider>
              <SubscriptionProvider>
                <InvoiceProvider>
                  <AppointmentProvider>
                    <StaffProvider>
                      <StaffTimeTrackingProvider>
                      {children}
                      </StaffTimeTrackingProvider>
                    </StaffProvider>
                  </AppointmentProvider>
                </InvoiceProvider>
              </SubscriptionProvider>
            </PackageProvider>
          </VehicleProvider>
        </CustomerProvider>
      </SettingsProvider>
    </ActivityProvider>
  );
}

